import { humanizeDateShort } from '@datetime';
import ClockIcon from '@icons/ClockIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

interface ReleaseAfterChipProps extends React.HTMLAttributes<HTMLDivElement> {
  releaseDate: Date;
}

function ReleaseAfterChip({ releaseDate, className, ...rest }: ReleaseAfterChipProps) {
  const { t } = useTranslation();
  return (
    <div
      className={classNames(
        'flex justify-center items-center gap-xxs px-xs py-xxs rounded-md',
        'cursor-default',
        'border-[1px]',
        'P5M',
        'w-max',
        setupForDark('border-dark'),
        setupForDark('text-primary'),
        'text-nowrap',
        className
      )}
      {...rest}
    >
      <div className='flex items-center gap-xxs'>
        <ClockIcon size={16} />
      </div>
      <div className='flex items-center gap-xxs'>{humanizeDateShort(releaseDate, t)}</div>
    </div>
  );
}

export default ReleaseAfterChip;
